import { ID, Response } from 'app/components/Table/core/types';

import { trimObject } from 'app/helpers';

import { API_URL } from 'app/constants/environments';

import { Address, AddressRequest, Customer, CustomersQueryResponse } from './type';
import axios, { AxiosResponse } from 'axios';
import { useOrganizationStore } from 'theme/layout/components/aside/store';

const CUSTOMERS_URL = `${API_URL}/api`;
const ADDRESS_URL = `${API_URL}/api`;

const getCustomers = (query?: string): Promise<CustomersQueryResponse> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  const params = query
    ? `${CUSTOMERS_URL}/orgs/${organizationId}/customers?${query}`
    : `${CUSTOMERS_URL}/orgs/${organizationId}/customers`;
  return axios.get(params).then(
    (
      d: AxiosResponse<{
        data: Customer;
      }>,
    ) => {
      return {
        data: d.data.data,
      };
    },
  );
};
const createCustomer = (request: FormData): Promise<Customer | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .post(`${CUSTOMERS_URL}/orgs/${organizationId}/customers`, request)
    .then((response: AxiosResponse<Response<Customer>>) => response.data)
    .then((response: Response<Customer>) => response.data);
};

const createAddress = (request: { items: AddressRequest[] }): Promise<Address[] | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .post(`${ADDRESS_URL}/orgs/${organizationId}/address`, request)
    .then((response: AxiosResponse<Response<Address[]>>) => response.data)
    .then((response: Response<Address[]>) => response.data);
};

const updateCustomer = (idCustomer: ID, request: FormData): Promise<Customer | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .patch(`${CUSTOMERS_URL}/orgs/${organizationId}/customers/${idCustomer}`, request)
    .then((response: AxiosResponse<Response<Customer>>) => response.data)
    .then((response: Response<Customer>) => response.data);
};

export { getCustomers, createCustomer, updateCustomer, createAddress };
